/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DenotationPartTypeConstants } from './DenotationPartTypeConstants';
import {
    DenotationPartTypeConstantsFromJSON,
    DenotationPartTypeConstantsFromJSONTyped,
    DenotationPartTypeConstantsToJSON,
} from './DenotationPartTypeConstants';

/**
 * All individual parts making up this denotation, to be separated with a whitespace each
 * @export
 * @interface Part
 */
export interface Part {
    /**
     * 
     * @type {DenotationPartTypeConstants}
     * @memberof Part
     */
    type: DenotationPartTypeConstants;
    /**
     * 
     * @type {string}
     * @memberof Part
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Part
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof Part
     */
    value?: string;
}

/**
 * Check if a given object implements the Part interface.
 */
export function instanceOfPart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;

    return isInstance;
}

export function PartFromJSON(json: any): Part {
    return PartFromJSONTyped(json, false);
}

export function PartFromJSONTyped(json: any, ignoreDiscriminator: boolean): Part {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': DenotationPartTypeConstantsFromJSON(json['type']),
        'url': !exists(json, 'url') ? undefined : json['url'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function PartToJSON(value?: Part | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': DenotationPartTypeConstantsToJSON(value.type),
        'url': value.url,
        'label': value.label,
        'value': value.value,
    };
}

